export default {
    props: {
        valueAxisAxisCrossingValue: {
            type: Object | Date | Array,
            kComposite: 'valueAxis.axisCrossingValue'
        }, 
        valueAxisBackground: {
            type: String,
            kComposite: 'valueAxis.background'
        }, 
        valueAxisColor: {
            type: String,
            kComposite: 'valueAxis.color'
        }, 
        valueAxisCrosshairColor: {
            type: String,
            kComposite: 'valueAxis.crosshair.color'
        }, 
        valueAxisCrosshairOpacity: {
            type: Number,
            kComposite: 'valueAxis.crosshair.opacity'
        }, 
        valueAxisCrosshairTooltipBackground: {
            type: String,
            kComposite: 'valueAxis.crosshair.tooltip.background'
        }, 
        valueAxisCrosshairTooltipBorderColor: {
            type: String,
            kComposite: 'valueAxis.crosshair.tooltip.border.color'
        }, 
        valueAxisCrosshairTooltipBorderDashType: {
            type: String,
            kComposite: 'valueAxis.crosshair.tooltip.border.dashType'
        }, 
        valueAxisCrosshairTooltipBorderWidth: {
            type: Number,
            kComposite: 'valueAxis.crosshair.tooltip.border.width'
        }, 
        valueAxisCrosshairTooltipColor: {
            type: String,
            kComposite: 'valueAxis.crosshair.tooltip.color'
        }, 
        valueAxisCrosshairTooltipFont: {
            type: String,
            kComposite: 'valueAxis.crosshair.tooltip.font'
        }, 
        valueAxisCrosshairTooltipFormat: {
            type: String,
            kComposite: 'valueAxis.crosshair.tooltip.format'
        }, 
        valueAxisCrosshairTooltipPadding: {
            type: Number,
            kComposite: 'valueAxis.crosshair.tooltip.padding'
        }, 
        valueAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            kComposite: 'valueAxis.crosshair.tooltip.padding.bottom'
        }, 
        valueAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            kComposite: 'valueAxis.crosshair.tooltip.padding.left'
        }, 
        valueAxisCrosshairTooltipPaddingRight: {
            type: Number,
            kComposite: 'valueAxis.crosshair.tooltip.padding.right'
        }, 
        valueAxisCrosshairTooltipPaddingTop: {
            type: Number,
            kComposite: 'valueAxis.crosshair.tooltip.padding.top'
        }, 
        valueAxisCrosshairTooltipTemplate: {
            type: String | Function,
            kComposite: 'valueAxis.crosshair.tooltip.template'
        }, 
        valueAxisCrosshairTooltipVisible: {
            type: Boolean,
            kComposite: 'valueAxis.crosshair.tooltip.visible'
        }, 
        valueAxisCrosshairVisible: {
            type: Boolean,
            kComposite: 'valueAxis.crosshair.visible'
        }, 
        valueAxisCrosshairWidth: {
            type: Number,
            kComposite: 'valueAxis.crosshair.width'
        }, 
        valueAxisLabelsBackground: {
            type: String,
            kComposite: 'valueAxis.labels.background'
        }, 
        valueAxisLabelsBorderColor: {
            type: String,
            kComposite: 'valueAxis.labels.border.color'
        }, 
        valueAxisLabelsBorderDashType: {
            type: String,
            kComposite: 'valueAxis.labels.border.dashType'
        }, 
        valueAxisLabelsBorderWidth: {
            type: Number,
            kComposite: 'valueAxis.labels.border.width'
        }, 
        valueAxisLabelsColor: {
            type: String,
            kComposite: 'valueAxis.labels.color'
        }, 
        valueAxisLabelsFont: {
            type: String,
            kComposite: 'valueAxis.labels.font'
        }, 
        valueAxisLabelsFormat: {
            type: String,
            kComposite: 'valueAxis.labels.format'
        }, 
        valueAxisLabelsMargin: {
            type: Number,
            kComposite: 'valueAxis.labels.margin'
        }, 
        valueAxisLabelsMarginBottom: {
            type: Number,
            kComposite: 'valueAxis.labels.margin.bottom'
        }, 
        valueAxisLabelsMarginLeft: {
            type: Number,
            kComposite: 'valueAxis.labels.margin.left'
        }, 
        valueAxisLabelsMarginRight: {
            type: Number,
            kComposite: 'valueAxis.labels.margin.right'
        }, 
        valueAxisLabelsMarginTop: {
            type: Number,
            kComposite: 'valueAxis.labels.margin.top'
        }, 
        valueAxisLabelsMirror: {
            type: Boolean,
            kComposite: 'valueAxis.labels.mirror'
        }, 
        valueAxisLabelsPadding: {
            type: Number,
            kComposite: 'valueAxis.labels.padding'
        }, 
        valueAxisLabelsPaddingBottom: {
            type: Number,
            kComposite: 'valueAxis.labels.padding.bottom'
        }, 
        valueAxisLabelsPaddingLeft: {
            type: Number,
            kComposite: 'valueAxis.labels.padding.left'
        }, 
        valueAxisLabelsPaddingRight: {
            type: Number,
            kComposite: 'valueAxis.labels.padding.right'
        }, 
        valueAxisLabelsPaddingTop: {
            type: Number,
            kComposite: 'valueAxis.labels.padding.top'
        }, 
        valueAxisLabelsRotation: {
            type: Number | String,
            kComposite: 'valueAxis.labels.rotation'
        }, 
        valueAxisLabelsRotationAlign: {
            type: String,
            kComposite: 'valueAxis.labels.rotation.align'
        }, 
        valueAxisLabelsRotationAngle: {
            type: Number | String,
            kComposite: 'valueAxis.labels.rotation.angle'
        }, 
        valueAxisLabelsSkip: {
            type: Number,
            kComposite: 'valueAxis.labels.skip'
        }, 
        valueAxisLabelsStep: {
            type: Number,
            kComposite: 'valueAxis.labels.step'
        }, 
        valueAxisLabelsTemplate: {
            type: String | Function,
            kComposite: 'valueAxis.labels.template'
        }, 
        valueAxisLabelsVisible: {
            type: Boolean,
            kComposite: 'valueAxis.labels.visible'
        }, 
        valueAxisLabelsVisual: {
            type: Function,
            kComposite: 'valueAxis.labels.visual'
        }, 
        valueAxisLineColor: {
            type: String,
            kComposite: 'valueAxis.line.color'
        }, 
        valueAxisLineDashType: {
            type: String,
            kComposite: 'valueAxis.line.dashType'
        }, 
        valueAxisLineVisible: {
            type: Boolean,
            kComposite: 'valueAxis.line.visible'
        }, 
        valueAxisLineWidth: {
            type: Number,
            kComposite: 'valueAxis.line.width'
        }, 
        valueAxisMajorGridLinesColor: {
            type: String,
            kComposite: 'valueAxis.majorGridLines.color'
        }, 
        valueAxisMajorGridLinesDashType: {
            type: String,
            kComposite: 'valueAxis.majorGridLines.dashType'
        }, 
        valueAxisMajorGridLinesType: {
            type: String,
            kComposite: 'valueAxis.majorGridLines.type'
        }, 
        valueAxisMajorGridLinesVisible: {
            type: Boolean,
            kComposite: 'valueAxis.majorGridLines.visible'
        }, 
        valueAxisMajorGridLinesWidth: {
            type: Number,
            kComposite: 'valueAxis.majorGridLines.width'
        }, 
        valueAxisMajorGridLinesStep: {
            type: Number,
            kComposite: 'valueAxis.majorGridLines.step'
        }, 
        valueAxisMajorGridLinesSkip: {
            type: Number,
            kComposite: 'valueAxis.majorGridLines.skip'
        }, 
        valueAxisMajorUnit: {
            type: Number,
            kComposite: 'valueAxis.majorUnit'
        }, 
        valueAxisMax: {
            type: Number,
            kComposite: 'valueAxis.max'
        }, 
        valueAxisMin: {
            type: Number,
            kComposite: 'valueAxis.min'
        }, 
        valueAxisMinorGridLinesColor: {
            type: String,
            kComposite: 'valueAxis.minorGridLines.color'
        }, 
        valueAxisMinorGridLinesDashType: {
            type: String,
            kComposite: 'valueAxis.minorGridLines.dashType'
        }, 
        valueAxisMinorGridLinesType: {
            type: String,
            kComposite: 'valueAxis.minorGridLines.type'
        }, 
        valueAxisMinorGridLinesVisible: {
            type: Boolean,
            kComposite: 'valueAxis.minorGridLines.visible'
        }, 
        valueAxisMinorGridLinesWidth: {
            type: Number,
            kComposite: 'valueAxis.minorGridLines.width'
        }, 
        valueAxisMinorGridLinesStep: {
            type: Number,
            kComposite: 'valueAxis.minorGridLines.step'
        }, 
        valueAxisMinorGridLinesSkip: {
            type: Number,
            kComposite: 'valueAxis.minorGridLines.skip'
        }, 
        valueAxisMajorTicksColor: {
            type: String,
            kComposite: 'valueAxis.majorTicks.color'
        }, 
        valueAxisMajorTicksSize: {
            type: Number,
            kComposite: 'valueAxis.majorTicks.size'
        }, 
        valueAxisMajorTicksVisible: {
            type: Boolean,
            kComposite: 'valueAxis.majorTicks.visible'
        }, 
        valueAxisMajorTicksStep: {
            type: Number,
            kComposite: 'valueAxis.majorTicks.step'
        }, 
        valueAxisMajorTicksSkip: {
            type: Number,
            kComposite: 'valueAxis.majorTicks.skip'
        }, 
        valueAxisMinorTicksColor: {
            type: String,
            kComposite: 'valueAxis.minorTicks.color'
        }, 
        valueAxisMinorTicksSize: {
            type: Number,
            kComposite: 'valueAxis.minorTicks.size'
        }, 
        valueAxisMinorTicksVisible: {
            type: Boolean,
            kComposite: 'valueAxis.minorTicks.visible'
        }, 
        valueAxisMinorTicksWidth: {
            type: Number,
            kComposite: 'valueAxis.minorTicks.width'
        }, 
        valueAxisMinorTicksStep: {
            type: Number,
            kComposite: 'valueAxis.minorTicks.step'
        }, 
        valueAxisMinorTicksSkip: {
            type: Number,
            kComposite: 'valueAxis.minorTicks.skip'
        }, 
        valueAxisMinorUnit: {
            type: Number,
            kComposite: 'valueAxis.minorUnit'
        }, 
        valueAxisName: {
            type: String,
            kComposite: 'valueAxis.name'
        }, 
        valueAxisNarrowRange: {
            type: Boolean,
            kComposite: 'valueAxis.narrowRange'
        }, 
        valueAxisPane: {
            type: String,
            kComposite: 'valueAxis.pane'
        }, 
        valueAxisPlotBands: {
            type: Array,
            kComposite: 'valueAxis.plotBands'
        },         valueAxisReverse: {
            type: Boolean,
            kComposite: 'valueAxis.reverse'
        }, 
        valueAxisTitleBackground: {
            type: String,
            kComposite: 'valueAxis.title.background'
        }, 
        valueAxisTitleBorderColor: {
            type: String,
            kComposite: 'valueAxis.title.border.color'
        }, 
        valueAxisTitleBorderDashType: {
            type: String,
            kComposite: 'valueAxis.title.border.dashType'
        }, 
        valueAxisTitleBorderWidth: {
            type: Number,
            kComposite: 'valueAxis.title.border.width'
        }, 
        valueAxisTitleColor: {
            type: String,
            kComposite: 'valueAxis.title.color'
        }, 
        valueAxisTitleFont: {
            type: String,
            kComposite: 'valueAxis.title.font'
        }, 
        valueAxisTitleMargin: {
            type: Number,
            kComposite: 'valueAxis.title.margin'
        }, 
        valueAxisTitleMarginBottom: {
            type: Number,
            kComposite: 'valueAxis.title.margin.bottom'
        }, 
        valueAxisTitleMarginLeft: {
            type: Number,
            kComposite: 'valueAxis.title.margin.left'
        }, 
        valueAxisTitleMarginRight: {
            type: Number,
            kComposite: 'valueAxis.title.margin.right'
        }, 
        valueAxisTitleMarginTop: {
            type: Number,
            kComposite: 'valueAxis.title.margin.top'
        }, 
        valueAxisTitlePadding: {
            type: Number,
            kComposite: 'valueAxis.title.padding'
        }, 
        valueAxisTitlePaddingBottom: {
            type: Number,
            kComposite: 'valueAxis.title.padding.bottom'
        }, 
        valueAxisTitlePaddingLeft: {
            type: Number,
            kComposite: 'valueAxis.title.padding.left'
        }, 
        valueAxisTitlePaddingRight: {
            type: Number,
            kComposite: 'valueAxis.title.padding.right'
        }, 
        valueAxisTitlePaddingTop: {
            type: Number,
            kComposite: 'valueAxis.title.padding.top'
        }, 
        valueAxisTitlePosition: {
            type: String,
            kComposite: 'valueAxis.title.position'
        }, 
        valueAxisTitleRotation: {
            type: Number,
            kComposite: 'valueAxis.title.rotation'
        }, 
        valueAxisTitleText: {
            type: String,
            kComposite: 'valueAxis.title.text'
        }, 
        valueAxisTitleVisible: {
            type: Boolean,
            kComposite: 'valueAxis.title.visible'
        }, 
        valueAxisTitleVisual: {
            type: Function,
            kComposite: 'valueAxis.title.visual'
        }, 
        valueAxisType: {
            type: String,
            kComposite: 'valueAxis.type'
        }, 
        valueAxisVisible: {
            type: Boolean,
            kComposite: 'valueAxis.visible'
        }, 
        valueAxisNotesPosition: {
            type: String,
            kComposite: 'valueAxis.notes.position'
        }, 
        valueAxisNotesIconBackground: {
            type: String,
            kComposite: 'valueAxis.notes.icon.background'
        }, 
        valueAxisNotesIconBorderColor: {
            type: String,
            kComposite: 'valueAxis.notes.icon.border.color'
        }, 
        valueAxisNotesIconBorderWidth: {
            type: Number,
            kComposite: 'valueAxis.notes.icon.border.width'
        }, 
        valueAxisNotesIconSize: {
            type: Number,
            kComposite: 'valueAxis.notes.icon.size'
        }, 
        valueAxisNotesIconType: {
            type: String,
            kComposite: 'valueAxis.notes.icon.type'
        }, 
        valueAxisNotesIconVisible: {
            type: Boolean,
            kComposite: 'valueAxis.notes.icon.visible'
        }, 
        valueAxisNotesLabelBackground: {
            type: String,
            kComposite: 'valueAxis.notes.label.background'
        }, 
        valueAxisNotesLabelBorderColor: {
            type: String,
            kComposite: 'valueAxis.notes.label.border.color'
        }, 
        valueAxisNotesLabelBorderDashType: {
            type: String,
            kComposite: 'valueAxis.notes.label.border.dashType'
        }, 
        valueAxisNotesLabelBorderWidth: {
            type: Number,
            kComposite: 'valueAxis.notes.label.border.width'
        }, 
        valueAxisNotesLabelColor: {
            type: String,
            kComposite: 'valueAxis.notes.label.color'
        }, 
        valueAxisNotesLabelFont: {
            type: String,
            kComposite: 'valueAxis.notes.label.font'
        }, 
        valueAxisNotesLabelTemplate: {
            type: String | Function,
            kComposite: 'valueAxis.notes.label.template'
        }, 
        valueAxisNotesLabelVisible: {
            type: Boolean,
            kComposite: 'valueAxis.notes.label.visible'
        }, 
        valueAxisNotesLabelRotation: {
            type: Number,
            kComposite: 'valueAxis.notes.label.rotation'
        }, 
        valueAxisNotesLabelFormat: {
            type: String,
            kComposite: 'valueAxis.notes.label.format'
        }, 
        valueAxisNotesLabelPosition: {
            type: String,
            kComposite: 'valueAxis.notes.label.position'
        }, 
        valueAxisNotesLineDashType: {
            type: String,
            kComposite: 'valueAxis.notes.line.dashType'
        }, 
        valueAxisNotesLineWidth: {
            type: Number,
            kComposite: 'valueAxis.notes.line.width'
        }, 
        valueAxisNotesLineColor: {
            type: String,
            kComposite: 'valueAxis.notes.line.color'
        }, 
        valueAxisNotesLineLength: {
            type: Number,
            kComposite: 'valueAxis.notes.line.length'
        }, 
        valueAxisNotesData: {
            type: Array,
            kComposite: 'valueAxis.notes.data'
        },         valueAxisNotesVisual: {
            type: Function,
            kComposite: 'valueAxis.notes.visual'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/ValueAxis.js